import { store } from "./index";
import { companySettingsSelector, currenciesSettingIndexerSelector } from "./slice/settings";

export const getCurrencyLabel = currencyCode => {
  const indexer = currenciesSettingIndexerSelector(store.getState());

  const result = indexer[currencyCode];

  if (!result) return currencyCode;

  return result;
};

export const isUseLatinNumber = window.appSettings.isRtl
  ? companySettingsSelector(store.getState()).useLatinNumber
  : true;
